import { placeholder } from '../content/placeholder'

/**
 * What / shows while HOMEPAGE_ENABLED is off: the name and one line, nothing
 * else. The noindex tag for this state is written into the HTML at build time.
 */
export function Placeholder() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <h1 className="text-2xl font-bold tracking-tight text-ink sm:text-3xl">
        {placeholder.wordmark}
      </h1>
      <p className="mt-3 text-base text-ink-soft">{placeholder.line}</p>
    </main>
  )
}
